import { render, staticRenderFns } from "./RateTab.vue?vue&type=template&id=8fbf6cf8&scoped=true"
import script from "./RateTab.vue?vue&type=script&lang=js"
export * from "./RateTab.vue?vue&type=script&lang=js"
import style0 from "./RateTab.vue?vue&type=style&index=0&id=8fbf6cf8&lang=scss&scoped=true"
import style1 from "./RateTab.vue?vue&type=style&index=1&id=8fbf6cf8&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbf6cf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fbf6cf8')) {
      api.createRecord('8fbf6cf8', component.options)
    } else {
      api.reload('8fbf6cf8', component.options)
    }
    module.hot.accept("./RateTab.vue?vue&type=template&id=8fbf6cf8&scoped=true", function () {
      api.rerender('8fbf6cf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/components/RateTab.vue"
export default component.exports